
function removeStringLiteralsIfExist(value) {
  if (typeof value !== 'string') return value;

  if (
    (value.startsWith('"') && value.endsWith('"')) ||
    (value.startsWith("'") && value.endsWith("'")) ||
    (value.startsWith('`') && value.endsWith('`'))
  ) {
    return value.slice(1, -1);
  }

  return value;
}
function removeOxIfExist(value) {
  if (typeof value !== 'string') return value;

  if (value.toLowerCase().startsWith('0x')) {
    return value.slice(2);
  }

  return value;
}



const shortOps = [
  { "value": "false", "int": 0 },
  { "value": "1negate", "int": 79 },
  { "value": "true", "int": 81 },
  { "value": "nop", "int": 97 },
  { "value": "if", "int": 99 },
  { "value": "notIf", "int": 100 },
  { "value": "else", "int": 103 },
  { "value": "endIf", "int": 104 },
  { "value": "verify", "int": 105 },
  { "value": "return", "int": 106 },
  { "value": "toAltStack", "int": 107 },
  { "value": "fromAltStack", "int": 108 },
  { "value": "2drop", "int": 109 },
  { "value": "2dup", "int": 110 },
  { "value": "3dup", "int": 111 },
  { "value": "2over", "int": 112 },
  { "value": "2rot", "int": 113 },
  { "value": "2swap", "int": 114 },
  { "value": "ifDup", "int": 115 },
  { "value": "depth", "int": 116 },
  { "value": "drop", "int": 117 },
  { "value": "dup", "int": 118 },
  { "value": "nip", "int": 119 },
  { "value": "over", "int": 120 },
  { "value": "pick", "int": 121 },
  { "value": "roll", "int": 122 },
  { "value": "rot", "int": 123 },
  { "value": "swap", "int": 124 },
  { "value": "tuck", "int": 125 },
  { "value": "cat", "int": 126 },
  { "value": "split", "int": 127 },
  { "value": "num2bin", "int": 128 },
  { "value": "bin2num", "int": 129 },
  { "value": "size", "int": 130 },
  { "value": "invert", "int": 131 },
  { "value": "and", "int": 132 },
  { "value": "or", "int": 133 },
  { "value": "xor", "int": 134 },
  { "value": "equal", "int": 135 },
  { "value": "equalVerify", "int": 136 },
  { "value": "1add", "int": 139 },
  { "value": "1sub", "int": 140 },
  { "value": "2mul", "int": 141 },
  { "value": "2div", "int": 142 },
  { "value": "negate", "int": 143 },
  { "value": "abs", "int": 144 },
  { "value": "not", "int": 145 },
  { "value": "0notEqual", "int": 146 },
  { "value": "add", "int": 147 },
  { "value": "sub", "int": 148 },
  { "value": "mul", "int": 149 },
  { "value": "div", "int": 150 },
  { "value": "mod", "int": 151 },
  { "value": "lShift", "int": 152 },
  { "value": "rShift", "int": 153 },
  { "value": "boolAnd", "int": 154 },
  { "value": "boolOr", "int": 155 },
  { "value": "numEqual", "int": 156 },
  { "value": "numEqualVerify", "int": 157 },
  { "value": "numNotEqual", "int": 158 },
  { "value": "lessThan", "int": 159 },
  { "value": "greaterThan", "int": 160 },
  { "value": "lessThanOrEqual", "int": 161 },
  { "value": "greaterThanOrEqual", "int": 162 },
  { "value": "min", "int": 163 },
  { "value": "max", "int": 164 },
  { "value": "within", "int": 165 },
  { "value": "ripemd160", "int": 166 },
  { "value": "sha1", "int": 167 },
  { "value": "sha256", "int": 168 },
  { "value": "hash160", "int": 169 },
  { "value": "hash256", "int": 170 },
  { "value": "codeSeparator", "int": 171 },
  { "value": "checkSig", "int": 172 },
  { "value": "checkSigVerify", "int": 173 },
  { "value": "checkMultiSig", "int": 174 },
  { "value": "checkMultiSigVerify", "int": 175 },
]

const nodeTypes = {
  root: 0,
  opcode: 1,
  comment: 2,
  argument: 3,
  template: 4,
  bigint: 5,
  hex: 6,
  string: 7,
  annotation: 8,
  repeat: 9,
  end: 10,
  function: 11,
  call: 12,
  import: 13,
  word: 14,
  whitespace: 15,
  section: 16,
  pushCodeData: 17
}

const getNodeTypeString = (type) => Object.keys(nodeTypes).find(
  (key) => nodeTypes[key] === type
)
const u2Hex = (uint8) => Buffer.from(uint8, 'utf8').toString('hex')
const nodeIsFlowControl = (node) => {
  // console.log('nodeIsFlowControl', node)
  return (
    node.type !== nodeTypes.repeat &&
    (node.value.toLowerCase() === 'if' ||
    node.value.toLowerCase() === 'else' ||
    node.value.toLowerCase() === 'endif' ||
    node.value.toLowerCase() === 'notif')
  )
}
export {
  nodeTypes,
  getNodeTypeString,
  shortOps,
  u2Hex,
  removeStringLiteralsIfExist,
  removeOxIfExist,
  nodeIsFlowControl
}
